export default function (element) {
  if (element) {
    element.scroll({
      top: 0,
      behavior: 'smooth',
    })
  }
}
